module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/google-play-badge-d222999f0aa4c5e04c7911f5f06a181a.png";